import {toFixedFloat} from "./utils";
import {Box3, Vector3} from "three";
import * as Globals from "../globals";
import {addWallElementBoundingBox} from "../models/walls/wall";

export function getVolume(geometry) {
    if (geometry === undefined) {
        return 0;
    }

    if (!geometry.isBufferGeometry) {
        console.log("'geometry' must be an indexed or non-indexed buffer geometry");
        return 0;
    }
    let isIndexed = geometry.index !== null;
    let position = geometry.attributes.position;
    let sum = 0;
    let p1 = new Vector3(),
        p2 = new Vector3(),
        p3 = new Vector3();
    if (!isIndexed) {
        let faces = position.count / 3;
        for (let i = 0; i < faces; i++) {
            p1.fromBufferAttribute(position, i * 3);
            p2.fromBufferAttribute(position, i * 3 + 1);
            p3.fromBufferAttribute(position, i * 3 + 2);
            sum += signedVolumeOfTriangle(p1, p2, p3);
        }
    } else {
        let index = geometry.index;
        let faces = index.count / 3;
        for (let i = 0; i < faces; i++) {
            p1.fromBufferAttribute(position, index.array[i * 3]);
            p2.fromBufferAttribute(position, index.array[i * 3 + 1]);
            p3.fromBufferAttribute(position, index.array[i * 3 + 2]);
            sum += signedVolumeOfTriangle(p1, p2, p3);
        }
    }
    return sum;
}

function signedVolumeOfTriangle(p1, p2, p3) {
    return p1.dot(p2.cross(p3)) / 6.0;
}


const cutCornerSideLength = 0.005;
export const elementEdgesArea = 4 * cutCornerSideLength * cutCornerSideLength / 2; //4 Ecken enthalten ein Dreieck mit 0.005 Seitenlänge: 0.005 * 0.005 > Viereck > Halbieren Dreick Fläche

//Neuberechnung des Volumens von Dach und Bodenelementen.
export function recalculateVolumes(elements) {
    /*Nach dem Schneiden muss bestimmt werden, ob die Elemente nur in der Länge beschnitten wurde.
    * Dazu kann das aktuelle Volumen mit dem errechneten Volumen auf Basis der Länge berechnet werden
    */
    for (let i = elements.length - 1; i >= 0; i--) {
        let child = elements[i];

        //Neuberechnung der originalVolume, wenn das Element nur in der Länge gekürzt wurde, um dieses nicht als geschnittenes Element zu verrechnen.

        //Aktuelle Volume
        let sizedVolume = toFixedFloat(getVolume(child.geometry), 7);
        child.userData.sizedVolume = sizedVolume;

        //Theoretische aktuelle Volume
        let bounds = new Box3().setFromObject(child);
        let size = bounds.getSize(new Vector3());

        let currentLength = size.z;
        let currentThickness = size.y;

        const roofElementArea = toFixedFloat(((Globals.HBESectionWidth * currentThickness) - elementEdgesArea), 7); //Fläche eines Dachelements

        let boundsVolume = toFixedFloat(roofElementArea * currentLength, 7); //Theoretisches volles Element Volumen (ungeschnitten)

        if (toFixedFloat(boundsVolume, 5) === toFixedFloat(sizedVolume, 5)) {
            child.userData.originalVolume = sizedVolume; //Wenn das aktuelle Volumen dem theoretischen Volumen entspricht wurde das Element nur zusätzlich auf die Länge geschnitten
        } else if (toFixedFloat(boundsVolume, 5) !== toFixedFloat(child.userData.originalVolume, 5)) {
            child.userData.originalVolume = boundsVolume;
        }


        let elementWidth = !child.userData.isLastElement ? size.x - Globals.HBEElementFederWidth : size.x;
        addWallElementBoundingBox(child, elementWidth, child.userData.wallElementHeight, child.userData.isLastElement, child.name.slice(-3));
    }
}

export function getElementWidth(element) {
    element.geometry.computeBoundingBox();
    let bounds = element.geometry.boundingBox;
    let size = bounds.getSize(new Vector3());
    return !element.userData.isLastElement ? size.x - Globals.HBEElementFederWidth : size.x;
}
